module.exports = __webpack_public_path__ + "static/Pavillions_pin_hover-74f5d6476418bb88f3a76fd6435d33d4.png";